<template>
    <v-main :style="contentMainStyle">
        <v-container class="containerDefault" :class="{ 'px-2': horizontalMargin }" fill-height>
            <v-layout :align-center="true" :style="contentLayoutStyle">
                <div style="position:absolute;top:0;left:0;right:0;bottom:0;">
                    <slot name="background"></slot>
                </div>
                <v-flex class="pt-4 px-4 card-column">
                    <v-row no-gutters>
                        <v-col cols="10" sm="11">
                            <h1 class="pr-5 pl-1 white--text" :style="{'color': cardTheme.backgroundColor + '!important' }">
                                <slot name="title"></slot>
                            </h1>
                        </v-col>
                        <v-col cols="2" sm="1" align="end" style="text-align: end;" :class="{ 'px-1 px-sm-0': hasActionSlot }">
                            <slot name="action"></slot>
                        </v-col>
                    </v-row>
                    <v-flex offset-10 class=" text-right" :class="{ 'px-1 px-sm-0': hasHeaderActionSlot }"
                        ><slot name="header-action"></slot
                    ></v-flex>
                    <v-card
                        ref="contentCard"
                        flat
                        rounded="lg"
                        :min-height="minHeight"
                        :height="useFixedHeight?cardHeight:null"
                        :class="disablePadding ? 'pa-0' : 'pa-1'"
                        :style="contentCardStyle"
                        :color="backgroundColor"
                    >
                        <v-card-title v-if="hasMenuSlot" class="pb-0 pt-1 ">
                            <v-toolbar flat color="rgba(255, 255, 255, 0)" class="px-0 menu-toolbar">
                                <v-toolbar-title style="width: 100%;">
                                    <v-row no-gutters>
                                        <v-col v-if="!hasMenuActionSlot" cols="12">
                                            <slot name="menuTitle"></slot>
                                        </v-col>
                                        <v-col v-if="hasMenuActionSlot" cols="8" sm="9" md="8">
                                            <slot name="menuTitle"></slot>
                                        </v-col>
                                        <v-col v-if="hasMenuActionSlot" cols="4" sm="3" md="4" align="end" style="text-align: end;">
                                            <slot name="menuAction"></slot>
                                        </v-col>
                                    </v-row>
                                </v-toolbar-title>
                            </v-toolbar>
                        </v-card-title>
                        <v-card-text :class="{ 'pa-0': disablePadding }">
                            <HLLoadingMaskOverlay v-show="loading" />
                            <slot v-show="!loading" name="content"></slot>
                        </v-card-text>
                        <v-card-actions v-if="hasFooterSlot">
                            <slot name="footer"></slot>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-main>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
import HLLoadingMaskOverlay from '@/components/ui/HLLoadingMaskOverlay.vue';
import { eventMixin } from '@/utils/event-mixin';
export default {
    mixins: [layoutMixin, eventMixin],
    props: {
        background: {
            type: String,
            default: null
        },
        useFixedHeight: {
            type: Boolean,
            default: true
        },
        scale: {
            type: Number,
            default: 0.7
        },
        minHeight: {
            type: String,
            default: null
        },
        horizontalMargin: {
            type: Boolean,
            default: true
        },
        disablePadding: {
            type: Boolean,
            default: false
        },
        disableFooterPadding: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        // color title and card with the build defaults instead of the event theme
        useAppTheme: {
            type: Boolean,
            default: false
        }
    },
    components: {
        HLLoadingMaskOverlay
    },
    data() {
        return {
            uuid: this.createId(),            
        };
    },
    computed: {
        contentLayoutStyle() {
            let style = {};
            if (!this.disableFooterPadding) {
                style['padding-bottom'] = this.isMdDevice || this.isSmDevice ? '75px' : '56px';
            }

            return style;
        },
        contentMainStyle() {
            let style = {
                /*
        'position':'fixed',
        'width':'100%',
        'height':'100%',
        'padding-top':'0'*/
            };
            if (this.background) {
                style['background'] = this.background;
            }
            return style;
        },
        contentCardStyle() {
            let style = {
                position: 'relative'
            };
            return style;
        },
        cardHeight() {
            return this.bgHeight * this.scale;
        },
        hasMenuSlot() {
            return !!this.$slots.menuTitle || this.hasMenuActionSlot;
        },
        hasMenuActionSlot() {
            return !!this.$slots.menuAction;
        },
        hasFooterSlot() {
            return !!this.$slots.footer;
        },
        hasActionSlot() {
            return !!this.$slots.action;
        },
        hasHeaderActionSlot() {
            return !!this.$slots['header-action'];
        },

        cardTheme() {
            return this.useAppTheme ? this.appTheme : this.theme;
        },

        /**
         * Card background color based on current route
         */
         backgroundColor() {
            let toReturn = this.cardTheme.backgroundColor;//default background color
            //special cases where we need other background
            if (['/login', '/eventlist', '/eventselect'].includes(this.$route.path)){
               toReturn = '#ffffff';
            }
            return toReturn;
        }
    },
    methods: {
        getCardContentHeight() {
            return this.$refs && this.$refs.contentCard ? this.$refs.contentCard.height : null;
        }        
    },
    /*
  mounted() {
    this.showTargetElement(document.querySelector(`#${this.uuid}`));
  },
  unmounted() {
    this.hideTargetElement(document.querySelector(`#${this.uuid}`));
  },
  */
    created() {        
    }
};
</script>

<style scoped>
.containerDefault {
    max-width: 700px !important;
}

/*
 * Title block and card stack in a column that never grows beyond the layout: the card keeps
 * its nominal height while there is room and gives way (down to its min-height) when the
 * viewport is low, so the page never pushes the footer out of view. Inside the card the text
 * area takes what title and actions leave and scrolls.
 */
.card-column {
    display: flex;
    flex-direction: column;
    max-height: 100%;
}
.card-column > * {
    flex: 0 0 auto;
}
.card-column > .v-card {
    display: flex;
    flex-direction: column;
    flex: 0 1 auto;
    min-height: 0;
}
.card-column > .v-card > * {
    flex: 0 0 auto;
}
.card-column > .v-card > .v-card__text {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
}
</style>
<style>
.menu-toolbar .v-toolbar__content {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
